module.exports = __webpack_public_path__ + "img/i_o_qu.63125b11.svg";